enum IncidentFilter {
  reported = 'reported',
  resolved = 'resolved',
  all = 'all',
}

export default IncidentFilter
